export default {"src":"/_next/static/media/aspen_logo_black@2x.a78e6603.svg","height":73,"width":158,"blurWidth":0,"blurHeight":0};